import { CommandCode } from "../../utils/network/generated/protoTypes";
import { networkNoticeCoopInfoHandler } from "./handlers/networkNoticeCoopInfoHandler";
import { networkNoticeProjectInfoHandler } from "./handlers/networkNoticeProjectInfoHandler";
export var networkNoticeNotificationHandlerMap = new Map()
    .set(CommandCode.CoopInfo, networkNoticeCoopInfoHandler)
    .set(CommandCode.CoopProjectInfo, networkNoticeProjectInfoHandler);



//////////////////
// WEBPACK FOOTER
// ./src/features/network/networkNoticeNotificationHandlerMap.ts
// module id = 2019
// module chunks = 3